import {Component, computed, inject, OnInit} from '@angular/core';
import {AppStore} from '../../shared/store/app.store';
import {ResultsStore} from '../../shared/store/results.store';
import {ISearchParams} from '../../types/ICart';
import {Tabs} from '../../shared/components/tabs/tabs';
import {Tab} from '../../shared/components/tabs/tab/tab';
import {Card} from '../../shared/components/card/card';
import {LookupStore} from '../../shared/store/lookup.store';
import {LookupByVehicle} from './components/lookup-by-vehicle/lookup-by-vehicle';
import {LookupBySize} from './components/lookup-by-size/lookup-by-size';
import {LookupByManual} from './components/lookup-by-manual/lookup-by-manual';
import {EventService} from '../../shared/services/event.service';
import {LookupHeaderComponent} from './components/lookup-header/lookup-header.component';
import {SettingsService} from '../../shared/services/settings.service';
import {ReleaseNotesModal} from './release-notes/release-notes-modal';

@Component({
  selector: 'app-lookup',
  standalone: true,
  imports: [Tabs, Tab, LookupByVehicle, LookupBySize, Card, LookupByManual, LookupHeaderComponent, ReleaseNotesModal],
  templateUrl: './lookup.component.html',
  styleUrl: './lookup.component.css'
})
export class LookupComponent implements OnInit {
  public resultsStore = inject(ResultsStore);

  settings = inject(SettingsService);
  appStore = inject(AppStore);
  private lookupStore = inject(LookupStore);
  private eventService = inject(EventService);

  readonly manualSearch = computed(() => {
    const request = this.appStore.cart.search_request();
    if (request.part_number) return {type: 'part_number' as const, value: request.part_number};
    return {type: 'rawsize' as const, value: request.rawsize ?? ''};
  });

  ngOnInit() {
    this.checkForSearchParams();
    this.eventService.emit('lookup-form-init', {});
  }

  private checkForSearchParams() {
    const cartParams = this.appStore.cart();

    if (cartParams.repair_order?.vehicle_year) {
      this.lookupStore.hydrateVehicle({
        year: cartParams.repair_order.vehicle_year,
        make: cartParams.repair_order.vehicle_make,
        model: cartParams.repair_order.vehicle_model
      })
    }

    if (cartParams.search_request?.rawsize) {
      this.lookupStore.hydrateSize(cartParams.search_request.rawsize);
    }
  }

  search(params: ISearchParams) {
    this.resultsStore.search(params);
  }
}
